export default __webpack_public_path__ + "static/media/insta.5fb5c30e.svg";